<template>
    <div class="kanban-container" ref="kanban">
        <div class="production-kanban-header">【{{ companyName }}】模具整备看板</div>

        <div style="overflow: auto;display: flex;">
            <div>
                <table class="mold-kanban-table">
                    <tr>
                        <td style="width: 35px;max-width: 35px;">模具编号</td>
                        <td style="width: 35px;max-width: 35px;">整备人员</td>
                        <td style="width: 55px;max-width: 55px;">完成时间</td>
                        <td style="width: 30px;max-width: 30px;">状态</td>
                        <td style="width: 45px; max-width: 45px;">备注</td>
                    </tr>

                    <tr :class="item.index % 2 == 1 ? 'kanban-tr' : 'kanban-tr-odd'" v-for="(item, index) in moldKanbanList" :key="index">
                        <td>{{ item.moldCode }}</td>
                        <td>{{ item.preparer }}</td>
                        <td>{{ item.completeTime }}</td>
                        
                        <td>{{ item.status }}</td>
                        <td style="border-right-color: black;">{{ item.remark }}</td>
                    </tr>
                </table>
            </div>

            <div>
                <table class="mold-kanban-table">
                    <tr>
                        <td style="width: 35px;max-width: 35px;">模具编号</td>
                        <td style="width: 35px;max-width: 35px;">整备人员</td>
                        <td style="width: 55px;max-width: 55px;">完成时间</td>
                        <td style="width: 30px;max-width: 30px;">状态</td>
                        <td style="width: 45px; max-width: 45px;">备注</td>
                    </tr>

                    <tr :class="item.index % 2 == 1 ? 'kanban-tr' : 'kanban-tr-odd'" v-for="(item, index) in moldKanbanListTwo"
                        :key="index">
                        <td style="border-left-color: black;">{{ item.moldCode }}</td>
                        <td>{{ item.preparer }}</td>
                        <td>{{ item.completeTime }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ item.remark }}</td>
                    </tr>
                </table>
            </div>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyId: '',
            companyName: '中国制造',

            moldKanbanList: [],
            moldKanbanListTwo: [],

            index: 0,

            pageIndex: 0,
            pageNum: 15,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll(val) {
            this.$axios({
                method: "get",
                url: "/shiro/mold/prepare/kb/tv?companyId=" + this.companyId + '&pageIndex=' + val,
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                var mkbl = data.data

                for (let i in mkbl) {
                    mkbl[i].index = i

                    if (mkbl[i].completeTime) {
                        mkbl[i].completeTime = this.$moment(mkbl[i].completeTime).format("YYYY-MM-DD")
                    } else {
                        mkbl[i].completeTime = ''
                    }

                    if (mkbl[i].status == 0) {
                        mkbl[i].status = '待整备'
                    } else if (mkbl[i].status == 1) {
                        mkbl[i].status = '已整备'
                    } else if (mkbl[i].status == 2) {
                        mkbl[i].status = '已确认'
                    } else {
                        mkbl[i].status = '闲置中'
                    }
                }

                if (val == 0) {
                    this.moldKanbanList = mkbl
                } else {
                    this.moldKanbanListTwo = mkbl
                }

            })
        },
        fullScreen() {
            // console.log('fullScreen')
            let element = this.$refs.kanban
            // console.log(element)

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {

        let url = window.location.href
        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {};

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0]
            let value = keyArr[1]
            result[name] = value
        })

        if (Object.keys(result).length >= 1) {
            // console.log(result)
            // console.log('result.cid')
            // console.log(result.cid)
            this.companyId = result.cid
            this.pageIndex = result.p
        }

        this.getAll(this.pageIndex)
        this.getAll((this.pageIndex + 1) * this.pageNum)

        this.$axios({
            method: "post",
            url: "/shiro/company/getKb",
            data: {
                id: this.companyId
            }, headers: {
                token: this.token
            }
        }).then(result => {
            this.companyName = result.data.data.companyName
        })

        setInterval(() => {
            this.getAll(this.pageIndex)
            this.getAll((this.pageIndex + 1) * this.pageNum)
        }, 20000)

    },
    updated() {
        var ele = document.getElementsByClassName('el-progress-bar__inner')

        // console.log('upp')
        // console.log(ele)
        for (let i in ele) {
            var str = ele[i].attributes.style.value
            // console.log(str)
            var s = str.indexOf(':')
            var e = str.indexOf('%')

            var w = str.substring(s + 1, e)
            // console.log('---')
            // console.log(s)
            if (parseInt(w) > 100) {
                // console.log('>100')
                ele[i].attributes.style.value = 'width:100%'
            }
        }

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 600px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kanban-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 100px;
}

.mold-kanban-table {
    width: 475px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 13px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
    border-spacing: 1px;

}

.kanban-tr-odd {
    /* font-size: 11px; */
    color: black;
    background-color: white;
}

.kanban-tr {
    /* font-size: 11px; */
    color: black;
    background-color: greenyellow;
}

.mold-kanban-table td {
    border: 1px solid white;
    padding: 0;
}

.kanban-tr-odd td,.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;

}

.el-pagination__total {
    color: green;
}
</style>